export default {choose_newsletter:'Choisissez newsletters dans la liste.',email_please:'Votre email?'};